module.exports = __webpack_public_path__ + "static/img/HU@2x.7dd6a71c.jpg";